module.exports = __webpack_public_path__ + "static/media/cover.9affd18c.png";